import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getBanners,
  addBanner as addLang,
  updateBanner as updateLang,
  deleteBanner as deleteLang,
  updateBannerStatus as updateLangStatus,
} from "../../services/bannerService";
import { toast } from "react-toastify";
import { redirect } from "react-router-dom";

const initialState = {
  banners: [],
  status: "idle", // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

// Fetch all banners
export const fetchBanners = createAsyncThunk(
  "banners/fetchBanners",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getBanners();
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Add a new banner
export const addBanner = createAsyncThunk(
  "banners/addBanner",
  async (banner, { rejectWithValue }) => {
    try {
      const response = await addLang(banner);
      toast.success(response.message || "Data added successfully!");
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);


// Update a banner
export const updateBanner = createAsyncThunk(
  "banners/updateBanner",
  async ({ id, banner, redirectUrl }, { rejectWithValue }) => {
    try {
      const response = await updateLang(id, banner, redirectUrl);
      toast.success(response.message || "Data updated successfully!");
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Update a banner status
export const updateBannerStatus = createAsyncThunk(
  "banners/updateBannerStatus",
  async ({ id, statusObj }, { rejectWithValue }) => {
    try {
      const response = await updateLangStatus(id, statusObj);
      toast.success(response.message || "Status updated successfully!");
      return { id, statusObj };
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Delete a banner
export const deleteBanner = createAsyncThunk(
  "banners/deleteBanner",
  async (id, { rejectWithValue }) => {
    try {
      let response = await deleteLang(id);
     toast.success(response.message || "Data deleted successfully!");
      return id;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

const bannerSlice = createSlice({
  name: "banners",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Banners
      .addCase(fetchBanners.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.banners = action.payload.data;
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

       // Update Banner Status
       .addCase(updateBannerStatus.fulfilled, (state, action) => {
        const {id,statusObj} = action.payload;

        // Ensure `state.languages` exists and is an array
        if (!Array.isArray(state.banners)) {
            return;
        }
        const index = state.banners.findIndex((banner) =>{
         return banner._id === id
        });
        if (index !== -1) {
          state.banners[index] = { ...state.banners[index], ...statusObj };
        }
      })

        // Add Banner
            .addCase(addBanner.fulfilled, (state, action) => {
              state.banners.unshift(action.payload.data); // Add at the beginning
            })
      
            // Update Banner
            .addCase(updateBanner.fulfilled, (state, action) => {
              const updatedBanner = action.payload.data;
      
              if (!Array.isArray(state.banners)) {
                  return;
              }
              const index = state.banners.findIndex((banner) =>{
               return banner._id === updatedBanner._id
              });
              if (index !== -1) {
                state.banners[index] = { ...state.banners[index], ...updatedBanner };
              }
            })


       // Delete Language
       .addCase(deleteBanner.fulfilled, (state, action) => {
        const deletedId = action.payload;
        state.banners = state.banners.filter((astro) => astro._id !== deletedId);
      });
     
  },
});

export const { clearError } = bannerSlice.actions;
export default bannerSlice.reducer;
